export const i18n = {
    he: {
        dir: 'rtl',
        login: 'כניסה למערכת',
        username: 'שם משתמש',
        password: 'סיסמה',
        login_button: 'התחברות מאובטחת',
        register: 'יצירת חשבון חדש',
        register_title: 'הרשמה למערכת',
        first_name: 'שם פרטי',
        last_name: 'שם משפחה',
        institution: 'מוסד לימודים',
        select_institution: 'בחר מוסד מתוך הרשימה...',
        create_account: 'צור חשבון',
        back_to_login: 'חזרה להתחברות',
        my_courses: 'הקורסים שלי',
        expiry_msg: 'תוקף המוסד פג. אנא פנה להנהלה.',
        wrong_details: 'פרטים שגויים. נסה שוב.',
        password_mismatch: 'הסיסמאות אינן תואמות',
        welcome: 'ברוך הבא',
        logout: 'התנתקות',
        view_teacher: 'תצוגת מורה',
        view_student: 'תצוגת תלמיד',
        view_admin: 'תצוגת מנהל',
        pending_approval: 'החשבון ממתין לאישור הנהלת המוסד.',
        approved: 'מאושר',
        pending: 'ממתין לאישור',
        approve: 'אשר',
        grid_view: 'כרטיסיות',
        table_view: 'טבלה',
        search_course: 'חפש קורס...',
        course_name: 'שם הקורס',
        age_group: 'גילאים',
        fields: 'תחומי דעת',
        status: 'סטטוס',
        actions: 'פעולות'
    },
    en: {
        dir: 'ltr',
        login: 'Login to System',
        username: 'Username',
        password: 'Password',
        login_button: 'Secure Login',
        register: 'Create New Account',
        register_title: 'Registration',
        first_name: 'First Name',
        last_name: 'Last Name',
        institution: 'Institution',
        select_institution: 'Select your institution...',
        create_account: 'Create Account',
        back_to_login: 'Back to Login',
        my_courses: 'My Courses',
        expiry_msg: 'Institution access expired. Contact admin.',
        wrong_details: 'Invalid credentials. Try again.',
        password_mismatch: 'Passwords do not match',
        welcome: 'Welcome',
        logout: 'Logout',
        view_teacher: 'Teacher View',
        view_student: 'Student View',
        view_admin: 'Admin View',
        pending_approval: 'Account pending admin approval.',
        approved: 'Approved',
        pending: 'Pending',
        approve: 'Approve',
        grid_view: 'Grid',
        table_view: 'Table',
        search_course: 'Search course...',
        course_name: 'Course Name',
        age_group: 'Ages',
        fields: 'Fields',
        status: 'Status',
        actions: 'Actions'
    },
    ar: {
        dir: 'rtl',
        login: 'تسجيل الدخول',
        username: 'اسم المستخدم',
        password: 'كلمة المرور',
        login_button: 'دخول آمن',
        register: 'إنشاء حساب جديد',
        register_title: 'تسجيل',
        first_name: 'الاسم الأول',
        last_name: 'اسم العائلة',
        institution: 'مؤسسة تعليمية',
        select_institution: 'اختر مؤسستك...',
        create_account: 'إنشاء حساب',
        back_to_login: 'العودة لتسجيل الدخول',
        my_courses: 'دوراتي',
        expiry_msg: 'انتهت صلاحية المؤسسة. اتصل بالمسؤول.',
        wrong_details: 'بيانات غير صحيحة. حاول مرة أخرى.',
        password_mismatch: 'كلمات المرور غير متطابقة',
        welcome: 'مرحباً',
        logout: 'تسجيل خروج',
        view_teacher: 'عرض كمعلم',
        view_student: 'عرض كطالب',
        view_admin: 'عرض كمسؤول',
        pending_approval: 'الحساب في انتظار موافقة الإدارة.',
        approved: 'موافق عليه',
        pending: 'قيد الانتظار',
        approve: 'موافقة',
        grid_view: 'شبكة',
        table_view: 'جدول',
        search_course: 'البحث عن دورة...',
        course_name: 'اسم الدورة',
        age_group: 'الأعمار',
        fields: 'المجالات',
        status: 'الحالة',
        actions: 'إجراءات'
    },
    ru: {
        dir: 'ltr',
        login: 'Вход в систему',
        username: 'Имя пользователя',
        password: 'Пароль',
        login_button: 'Безопасный вход',
        register: 'Создать новый аккаунт',
        register_title: 'Регистрация',
        first_name: 'Имя',
        last_name: 'Фамилия',
        institution: 'Учебное заведение',
        select_institution: 'Выберите ваше заведение...',
        create_account: 'Создать аккаунт',
        back_to_login: 'Вернуться ко входу',
        my_courses: 'Мои курсы',
        expiry_msg: 'Срок действия истек. Обратитесь к администратору.',
        wrong_details: 'Неверные данные. Попробуйте еще раз.',
        password_mismatch: 'Пароли не совпадают',
        welcome: 'Добро пожаловать',
        logout: 'Выйти',
        view_teacher: 'Вид учителя',
        view_student: 'Вид ученика',
        view_admin: 'Вид админа',
        pending_approval: 'Аккаунт ожидает подтверждения администратора.',
        approved: 'Одобрен',
        pending: 'В ожидании',
        approve: 'Одобрить',
        grid_view: 'Сетка',
        table_view: 'Таблица',
        search_course: 'Поиск курса...',
        course_name: 'Название курса',
        age_group: 'Возраст',
        fields: 'Области',
        status: 'Статус',
        actions: 'Действия'
    }
};
